import { useSessionPermission } from '@btime/react-session'
import React from 'react'

import { useOpenEditAssetModal } from '../../../utils/routes/modals/modalsActions'
import FixedRoundButton from '../../../components/actions/FixedRoundButton'

const AddNewButton = () => {
  const hasAddPermission = useSessionPermission('createAsset')
  const openModal = useOpenEditAssetModal()
  if (!hasAddPermission) return false

  return <FixedRoundButton onClick={openModal} />
}

export default AddNewButton
